const normalizeText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

export const isTemplatePromptValue = (value, prompts = []) => {
  const normalized = normalizeText(value);
  if (!normalized) return false;
  return prompts.some((prompt) => normalizeText(prompt) === normalized);
};

export const getEditableTextValue = (value, prompts = []) => (
  isTemplatePromptValue(value, prompts) ? '' : (value || '')
);

export const getEditablePlaceholder = (fallback, value, prompts = []) => (
  isTemplatePromptValue(value, prompts) ? value : fallback
);

export const normalizeTemplateTextPatch = (field, value, prompts = []) => ({
  [field]: isTemplatePromptValue(value, prompts) ? '' : value,
});
